import ModalWrapper from '../../components/modals/ModalWrapper';
import LoginForm from './LoginForm';
import OtpForm from './OtpForm';
import Turnstile from 'react-turnstile';
import useOtpFlow from './useOtpFlow';
import { IModal } from '../../router/ModalRouter';
import { Modals } from '../../exports/Enums';
import ModalHeader from '../../components/modals/ModalHeader';
import Button from '../../components/buttons/Button';
import { FC } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

const LoginModal: FC<Partial<IModal>> = ({ closeModal, openModal }) => {
  const { hasTurnstile, otpResult, send, resend, loading, attachToken } = useOtpFlow();
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Modals:Login:LoginModal' });
  const hasOtpForm = otpResult.isSuccess;

  const SignUp: FC<{ className?: string }> = ({ className }): JSX.Element => {
    return (
      <div className={classnames('flex items-center justify-center w-full', className)}>
        <p className="!text-gray-700">{t('labels.dont_have_account')}</p>
        <Button
          title={t('buttons.sign_up')}
          slot="end"
          design="link"
          onClick={() => openModal({ id: Modals.Signup })}
          className="ml-[3px]"
        />
      </div>
    );
  };

  return (
    <>
      <ModalWrapper className={'h-[80dvh]'}>
        <ModalHeader title={t('title')} onClose={closeModal} />
        <div className="pt-md space-y-md px-sm">
          {hasOtpForm ? (
            <OtpForm onSuccess={closeModal} defaultValues={otpResult.data} onResendClick={resend} />
          ) : (
            <LoginForm onSubmit={send} loading={loading}>
              {hasTurnstile && !hasOtpForm && (
                <Turnstile
                  sitekey={import.meta.env.VITE_TURNSTILE_SITEKEY}
                  theme="light"
                  className="text-center"
                  onVerify={attachToken}
                />
              )}
            </LoginForm>
          )}
        </div>
        {!hasOtpForm && <SignUp className="mt-sm" />}
      </ModalWrapper>
    </>
  );
};

export default LoginModal;
